import { Button, Dialog, DialogContent } from "@mui/material";

export const CustomAlretDialog = ({ open, close, message }) => {

  return (
    <Dialog open={open} onClose={close}>
      <DialogContent>
        <p style={{ fontSize: 16 }}>{message}</p>
      </DialogContent>
      <Button
        onClick={close}>닫기</Button>
    </Dialog>
  );
};